<template>
  <div class="headline section-title primary--text">
    {{title}}
    <span v-if="required" class="required">*</span>
  </div>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "SectionTitle",
    props: {
      title: {
        type: String
      },
      required: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped lang="sass">
.section-title
  border-left: solid #2f3e6d 8px
  padding-left: 8px
.required
  color: red
  margin-left: 8px

</style>